/**
 * API para relatórios de sessões de trabalho
 * 
 * @author Equipe GestaoeCRM
 * @date 02/10/2025
 */

import api from './api';

export interface CompanyStats {
  totalSessions: number;
  activeSessions: number;
  completedSessions: number;
  totalHours: number;
  totalValue: number;
  sessionsByUser: Array<{
    userId: string;
    userName: string;
    sessionCount: number;
    totalHours: number;
    totalValue: number;
    hasHourRate?: boolean;
  }>;
  hourlyRate: number;
  usersWithoutHourRate?: Array<{
    userId: string;
    userName: string;
    sessionCount: number;
    totalHours: number;
  }>;
}

export interface UserStats {
  totalSessions: number;
  activeSessions: number;
  completedSessions: number;
  totalHours: number;
  totalValue: number;
  hourlyRate: number;
  activeProjects: number;
  demandsWithoutProject: number;
}

/**
 * Busca estatísticas de sessões da empresa
 */
export const getCompanyStats = async (timeRange: 'today' | 'week' | 'month' = 'today') => {
  const response = await api.get('/work-session-reports/company-stats', {
    params: { timeRange }
  });
  return response.data;
};

/**
 * Busca estatísticas de sessões do usuário atual
 */
export const getUserStats = async (timeRange: 'today' | 'week' | 'month' = 'today') => {
  const response = await api.get('/work-session-reports/user-stats', {
    params: { timeRange }
  });
  return response.data;
};

/**
 * Busca relatório detalhado de sessões
 */
export const getDetailedReport = async (params: {
  startDate?: string;
  endDate?: string;
  userId?: string;
  projectId?: string;
  page?: number;
  limit?: number;
}) => {
  const response = await api.get('/work-session-reports/detailed', {
    params
  });
  return response.data;
};

/**
 * Busca métricas do dashboard
 */
export const getDashboardMetrics = async () => {
  const response = await api.get('/work-session-reports/dashboard');
  return response.data;
};

/**
 * Gera relatório de uma OS específica
 */
export const generateOSReport = async (osId: string) => {
  const response = await api.get(`/work-session-reports/os/${osId}`);
  return response.data;
};

export const workSessionReportsApi = {
  getCompanyStats,
  getUserStats,
  getDetailedReport,
  getDashboardMetrics,
  generateOSReport
};